import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const getCountryAssignments = createSelector(appSettingsState, (appSettings) => appSettings.apiSettings?.data?.CountryAssignments);
